import * as React from "react";
import "./loader.scss";

export default function Loader(): React.ReactElement {
    return <div className="loader" data-testid="loader"/>;
}
